import { Chip } from "@mui/material";
import PropTypes from "prop-types";

import {
  getPaymentBadgeColor,
  getPaymentBadgeLabel,
} from "./paymentGatewayUtils";

const PaymentStatusBadge = ({ state, label, size = "small", sx, ...rest }) => {
  const resolvedState = state || "Unknown";
  const resolvedLabel = label || getPaymentBadgeLabel(resolvedState);

  return (
    <Chip
      size={size}
      label={resolvedLabel}
      color={getPaymentBadgeColor(resolvedState)}
      variant="outlined"
      sx={sx}
      {...rest}
    />
  );
};

PaymentStatusBadge.propTypes = {
  state: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium"]),
  sx: PropTypes.object,
};

export default PaymentStatusBadge;
